module.exports = function serializeMessage(message) {
  return JSON.stringify(message);
};



// WEBPACK FOOTER //
// ./src/js/RaptorSession/raptor/serializeMessage.js